export{TypographyComponent,TypographySize,TypographyVariant,TypographyWeight}from"./typography.component.js";
//# sourceMappingURL=index.js.map
